import ApplicationResponse, { ApplicationData } from '../../../api/dtos/application/ApplicationResponse';
import { ApplicationVersionData } from '../../../api/dtos/application/ApplicationVersionResponse';
import { GlobalApiActionTypes } from '../types';

export interface ApplicationState {
    application: ApplicationResponse | null;
    applications: ApplicationData[];
    versions: ApplicationVersionData[];
    isLoaded: boolean;
}

export const API_APPLICATIONS_LOADED = 'API_APPLICATIONS_LOADED';
export const API_APPLICATION_UPDATED = 'API_APPLICATION_UPDATED';
export const API_APPLICATION_VERSIONS_LOADED = 'API_APPLICATION_VERSIONS_LOADED';
export const API_APPLICATION_DEPLOYED = 'API_APPLICATION_DEPLOYED';
export const API_APPLICATION_REMOVED = 'API_APPLICATION_REMOVED';

interface ApplicationsLoadedAction {
    type: typeof API_APPLICATIONS_LOADED;
    applications: ApplicationData[];
}

interface ApplicationUpdatedAction {
    type: typeof API_APPLICATION_UPDATED;
    applicationId: number;
    application: ApplicationResponse;
}

interface ApplicationVersionsLoadedAction {
    type: typeof API_APPLICATION_VERSIONS_LOADED;
    versions: ApplicationVersionData[];
}

interface ApplicationDeployedAction {
    type: typeof API_APPLICATION_DEPLOYED;
}

interface ApplicationRemovedAction {
    type: typeof API_APPLICATION_REMOVED;
    applicationId: number;
}

export type ApplicationActionTypes =
    GlobalApiActionTypes
    | ApplicationsLoadedAction
    | ApplicationUpdatedAction
    | ApplicationVersionsLoadedAction
    | ApplicationDeployedAction
    | ApplicationRemovedAction;
